import React, { memo, useCallback } from "react";
import { cn } from "../../../lib/helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

const AnswerButton = memo(({
  option,
  questionId,
  isSelected,
  onChange,
  isMobile = false
}) => {
  // Handle touch events for immediate feedback on mobile
  const handleTouchStart = useCallback((e) => {
    if (isMobile) {
      e.currentTarget.style.transform = 'scale(0.95)';
    }
  }, [isMobile]);

  const handleTouchEnd = useCallback((e) => {
    if (isMobile) {
      e.currentTarget.style.transform = 'scale(1)';
      onChange(option.value);
    }
  }, [isMobile, onChange, option.value]);

  const handleClick = useCallback((e) => {
    // Prevent default click on mobile if touch was handled
    if (!isMobile) {
      onChange(option.value);
    }
  }, [isMobile, onChange, option.value]);
  const getAnswerButtonClasses = (optionValue, selected) => {
    const baseClasses = isMobile
      ? "group w-12 h-12 rounded-full border-4 font-bold flex items-center justify-center transition-colors duration-100 active:scale-95 touch-manipulation select-none"
      : "group w-10 h-10 rounded-full border-4 font-bold flex items-center justify-center transition-colors duration-100 touch-manipulation select-none";

    if (selected) {
      switch (optionValue) {
        case 1:
          return cn(baseClasses, "bg-superhero-nope border-transparent text-black");
        case 2:
          return cn(baseClasses, "bg-superhero-maybe border-transparent text-black");
        case 3:
          return cn(baseClasses, "bg-superhero-agree border-transparent text-black");
        case 4:
          return cn(baseClasses, "bg-superhero-link border-transparent text-black");
        default:
          return cn(baseClasses, "bg-dark-60 border-transparent text-dark-60");
      }
    } else {
      switch (optionValue) {
        case 1:
          return cn(baseClasses, "border-superhero-nope hover:text-superhero-nope text-transparent active:text-superhero-nope");
        case 2:
          return cn(baseClasses, "border-superhero-maybe hover:text-superhero-maybe text-transparent active:text-superhero-maybe");
        case 3:
          return cn(baseClasses, "border-superhero-agree hover:text-superhero-agree text-transparent active:text-superhero-agree");
        case 4:
          return cn(baseClasses, "border-superhero-link hover:text-superhero-link text-transparent active:text-superhero-link");
        default:
          return cn(baseClasses, "border-dark-50 text-dark-50");
      }
    }
  };

  const getHeaderTextColor = (optionValue) => {
    switch (optionValue) {
      case 1:
        return "text-superhero-nope";
      case 2:
        return "text-superhero-maybe";
      case 3:
        return "text-superhero-agree";
      case 4:
        return "text-superhero-link";
      default:
        return "text-light-80";
    }
  };

  return (
    <div className={isMobile ? "flex flex-col items-center" : "flex justify-center"}>
      <label
        className="cursor-pointer"
        style={{ WebkitTapHighlightColor: 'transparent' }}
        onTouchStart={isMobile ? handleTouchStart : undefined}
        onTouchEnd={isMobile ? handleTouchEnd : undefined}
        onClick={handleClick}
      >
        <input
          type="radio"
          name={`question-${questionId}`}
          value={option.value}
          checked={isSelected}
          onChange={() => {}}
          className="sr-only"
        />
        <div
          className={getAnswerButtonClasses(option.value, isSelected)}
          style={{ willChange: 'transform' }}
        >
          <FontAwesomeIcon
            icon={faCheck}
            className={isSelected ? null : (isMobile ? "hidden" : "hidden")}
          />
        </div>
      </label>
      {isMobile && (
        <div className="text-xs text-center mt-2">
          <div className={getHeaderTextColor(option.value)}>
            {option.text}
          </div>
        </div>
      )}
    </div>
  );
});

AnswerButton.displayName = 'AnswerButton';

export { AnswerButton };